import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportOptOutResponse } from '../../../Models/Models/Reports/ReportOptOutResponse';

declare var IS_RUNNING_IN_APP_POOL;

export class ReportOptOutSettingsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(clAccountId: string): Promise<ReportOptOutResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Settings/ReportOptOutSettings/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clAccountId: clAccountId }

    return AjaxWrapper.get<ReportOptOutResponse, any>(url, data);
  }
  public put(clAccountId: string, optOutContractNote: boolean): Promise<ReportOptOutResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/Settings/ReportOptOutSettings/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clAccountId: clAccountId, optOutContractNote: optOutContractNote }

    return AjaxWrapper.put<ReportOptOutResponse, any>(url, data);
  }
}

